import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH PROVIDERS - TABLE DATA ********************
export const fetchProviders = () => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_PROVIDERS_LOADING,
			payload: true
		});

		// request url
		const url = `/vod/listProviders?`;
		const { data } = await services.get(url);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_PROVIDERS_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_PROVIDERS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
